import { Keyboard, Dimensions } from "react-native";
import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import IllustrationContainer from "./IllustrationContainer";
import { styles } from "./styles/LoginScreenStyles";

type SharedAuthProps = {
  children: React.ReactNode;
  title?: string;
  isLoginMode: boolean;
  loginDividerText: string;
};

const SharedAuthComponent: React.FC<SharedAuthProps> = ({
  children,
  title = "India's #1 Zero-Commission Food Delivery App",
  isLoginMode,
  loginDividerText,
}) => {
  const [showIllustrationContainer, setShowIllustrationContainer] =
    useState(true);
  const scrollViewRef = React.useRef<ScrollView>(null);

  useEffect(() => {
    const keyboardDidShowListener = Keyboard.addListener(
      "keyboardDidShow",
      () => {
        setShowIllustrationContainer(false);
        scrollViewRef.current?.scrollTo({ y: 0, animated: true });
      }
    );

    const keyboardDidHideListener = Keyboard.addListener(
      "keyboardDidHide",
      () => setShowIllustrationContainer(true)
    );

    return () => {
      keyboardDidShowListener.remove();
      keyboardDidHideListener.remove();
    };
  }, []);

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
        style={styles.mainContainer}
      >
        <ScrollView
          ref={scrollViewRef}
          contentContainerStyle={styles.scrollContainer}
          keyboardShouldPersistTaps="handled"
        >
          {showIllustrationContainer && <IllustrationContainer />}

          <View style={styles.contentContainer}>
            <Text style={styles.title}>{title}</Text>

            <View style={styles.dividerContainer}>
              <View style={styles.divider} />
              <Text style={styles.subtitle}>
                {isLoginMode ? loginDividerText : "Create new account"}
              </Text>
              <View style={styles.divider} />
            </View>

            {children}
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

export default SharedAuthComponent;
